import { Routes, Route } from "react-router-dom";
import './App.css';
import Home from './components/home';
import Test from './components/test';

function App() {

  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="test/:category" element={<Test />} />
      </Routes>
    </div>
  );
}

export default App;
